// ─── Types ───────────────────────────────────────────────────────────────────

export type KfaTab = 'shift-handover' | 'leadership-walk' | 'sparc-walk' | 'observations' | 'nho' | 'racking-inspection' | 'site-evaluation';

export interface KfaFilterValues {
  modules: string;
  locationType: string;
  orgType: string;
  thirdPartyStatus: string;
  category: string;
  status: string;
}

// ─── Filter defaults ──────────────────────────────────────────────────────────

export const EMPTY_FILTERS: KfaFilterValues = {
  modules: '',
  locationType: '',
  orgType: '',
  thirdPartyStatus: '',
  category: '',
  status: '',
};

// ─── Notification messages ────────────────────────────────────────────────────

export const EDIT_SUCCESS_MESSAGE = 'Key Focus Area updated successfully';

// ─── Filter option lists ──────────────────────────────────────────────────────

export const TAB_MODULE_OPTIONS: Record<KfaTab, { id: string; displayText: string }[]> = {
  'shift-handover': [{ id: 'Shift Handover', displayText: 'Shift Handover' }],
  'leadership-walk': [{ id: 'Leadership Walk', displayText: 'Leadership Walk' }],
  'sparc-walk': [{ id: 'SPARC Walk', displayText: 'SPARC Walk' }],
  observations: [{ id: 'Observations', displayText: 'Observations' }],
  nho: [{ id: 'NHO', displayText: 'NHO' }],
  'racking-inspection': [{ id: 'Racking Inspection', displayText: 'Racking Inspection' }],
  'site-evaluation': [{ id: 'Site Evaluation', displayText: 'Site Evaluation' }],
};

export const LOCATION_TYPE_OPTIONS = [
  { id: 'Distribution', displayText: 'Distribution' },
  { id: 'Manufacturing', displayText: 'Manufacturing' },
  { id: 'Production', displayText: 'Production' },
];

export const ORG_TYPE_OPTIONS = [
  { id: '1NA', displayText: '1NA' },
  { id: 'FLNA', displayText: 'FLNA' },
  { id: 'PBNA', displayText: 'PBNA' },
];

export const THIRD_PARTY_STATUS_OPTIONS = [
  { id: 'Yes', displayText: 'Yes' },
  { id: 'No', displayText: 'No' },
];

export const CATEGORY_OPTIONS = [
  { id: 'Accuracy', displayText: 'Accuracy' },
  { id: 'Costs', displayText: 'Costs' },
  { id: 'People', displayText: 'People' },
  { id: 'Reliability', displayText: 'Reliability' },
  { id: 'Safety', displayText: 'Safety' },
];

export const STATUS_OPTIONS = [
  { id: 'Enabled', displayText: 'Enabled' },
  { id: 'Disabled', displayText: 'Disabled' },
];

// Maps each tab to the module name passed to KfaAddOverlay.
// 'main' triggers checkbox-based selection; all others auto-activate their section.
export const TAB_TO_MODULE: Record<KfaTab, string> = {
  'shift-handover': 'Shift Handover',
  'leadership-walk': 'Leadership Walk',
  'sparc-walk': 'SPARC Walk',
  observations: 'Observations',
  nho: 'NHO',
  'racking-inspection': 'Racking Inspection',
  'site-evaluation': 'Site Evaluation',
};

// ─── Tab configuration ────────────────────────────────────────────────────────

export const KFA_TABS: { key: KfaTab; label: string; moduleIds: string[] }[] = [
  {
    key: 'shift-handover',
    label: 'Shift Handover',
    moduleIds: ['shift-handover'],
  },
  {
    key: 'leadership-walk',
    label: 'Leadership Walk',
    moduleIds: ['leadership-walk'],
  },
  {
    key: 'sparc-walk',
    label: 'SPARC Walk',
    moduleIds: ['sparc-walk'],
  },
  {
    key: 'observations',
    label: 'Observations',
    moduleIds: ['observations'],
  },
  {
    key: 'nho',
    label: 'NHO',
    moduleIds: ['nho'],
  },
  {
    key: 'racking-inspection',
    label: 'Racking Inspection',
    moduleIds: ['racking-inspection'],
  },
  {
    key: 'site-evaluation',
    label: 'Site Evaluation',
    moduleIds: ['site-evaluation'],
  },
];
